import API from "../Api";

export interface NotificationEntry {
    type: string
    title: string
    desc: string
    created_at: string
    actions: {
        [name: string]: string
    }
    arguments?: any
    issuer: string
    date: any
    details: any
    action: string

}

export default class Notification {
    public id: string;
    public data: NotificationEntry;
  
    constructor(id: string, data: NotificationEntry) {
        this.id = id;
        if(!data.actions) {
            data.actions = {};
        }
        this.data = data;
    }

    async do(action: string): Promise<any> {
        return API("/api/v1/user?type=notification", {
            method: "POST",
            body: JSON.stringify({
                "id": this.id,
                "action": action,
            }),
        })
    }

    hasActions(): boolean {
        if(this.data.actions) {
            return Object.keys(this.data.actions).length > 0
        }
        return false;
    }
}